module.exports = __webpack_public_path__ + "static/media/youtube-frame-border.2e0987c1.png";